import { useState } from 'react';
import { updateProfile } from '../api';
import './PhonePromptModal.css';

export default function PhonePromptModal({ auth, onSaved, onSkip }) {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async (e) => {
    e.preventDefault();
    const trimmed = phone.trim();
    if (!trimmed) return;
    setError('');
    setLoading(true);
    try {
      const data = await updateProfile(auth.token, { mobile_number: trimmed });
      if (data.success) {
        onSaved({ ...auth.user, ...(data.user || { mobile_number: trimmed }) });
      } else {
        setError(data.message || 'Failed to save. Please try again.');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="phone-modal-overlay">
      <div className="phone-modal">
        <div className="phone-modal-icon">📱</div>
        <h2 className="phone-modal-title">Add your phone number</h2>
        <p className="phone-modal-subtitle">
          We use your mobile number for account security and important updates.
        </p>
        <form className="phone-modal-form" onSubmit={handleSave}>
          <input
            className="phone-modal-input"
            type="tel"
            placeholder="+91 98765 43210"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            disabled={loading}
            autoFocus
          />
          {error && <div className="phone-modal-error">{error}</div>}
          <button
            className="phone-modal-btn-primary"
            type="submit"
            disabled={loading || !phone.trim()}
          >
            {loading ? 'Saving…' : 'Save & Continue'}
          </button>
        </form>
        <button className="phone-modal-btn-skip" onClick={onSkip} disabled={loading}>
          Skip for now
        </button>
      </div>
    </div>
  );
}
